import './SerialTicketsBooking.scss'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import {
  getSerialTicketsGroupedByRouteAndType,
  isSerialTicketsLoading,
  isSerialTicketsMode as isSerialTicketsModeSelector
} from '../../selectors/selectors'
import Loader from '../common/Loader'
import Route from '../common/Route'
import SerialTicket from './SerialTicket/SerialTicket'

export default function SerialTicketsBooking() {
  const { t } = useTranslation()
  const serialTickets = useSelector(getSerialTicketsGroupedByRouteAndType)
  const serialTicketsLoading = useSelector(isSerialTicketsLoading)
  const isSerialTicketsMode = useSelector(isSerialTicketsModeSelector)

  return (
    <>
      {serialTicketsLoading && <Loader />}
      <div className="serial-tickets-booking">
        {serialTickets.map(({ from, to, groups }) => (
          <div className="serial-tickets-group" key={from + to}>
            <Route from={from} to={to} />
            {groups.map(({ type, serialTickets }) => (
              <React.Fragment key={type}>
                <div className="table-header">
                  <div className="type">{t(`type.${type.toLowerCase()}`)}</div>
                  <div className="price">{t('price.price')}</div>
                  <div className="amount">{t('price.amount')}</div>
                </div>
                {isSerialTicketsMode && <div className="description">{t(`description.${type.toLowerCase()}`)}</div>}
                <div className="serial-tickets-table">
                  {serialTickets.map(ticket => (
                    <SerialTicket key={ticket.code} ticket={ticket} />
                  ))}
                </div>
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
    </>
  )
}
